module.exports = __webpack_public_path__ + "media/images/riders/DEAN_LUCAS-64f8bc33df5869612bda8a208ac24e8f.png";